/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Edit_Marker_LabelInputs */

const en_markers_edit_marker_label = /** @type {(inputs: Markers_Edit_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit selected marker`)
};

const fr_markers_edit_marker_label = /** @type {(inputs: Markers_Edit_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier le marqueur selectionne`)
};

const de_markers_edit_marker_label = /** @type {(inputs: Markers_Edit_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählten Marker bearbeiten`)
};

const it_markers_edit_marker_label = /** @type {(inputs: Markers_Edit_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica il marcatore selezionato`)
};

const ru_markers_edit_marker_label = /** @type {(inputs: Markers_Edit_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактировать выбранный маркер`)
};

const es_markers_edit_marker_label = /** @type {(inputs: Markers_Edit_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar marcador seleccionado`)
};

const zh_cn2_markers_edit_marker_label = /** @type {(inputs: Markers_Edit_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑选定标记`)
};

const ja_markers_edit_marker_label = /** @type {(inputs: Markers_Edit_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したマーカーを編集`)
};

const hi_markers_edit_marker_label = /** @type {(inputs: Markers_Edit_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित मार्कर को संपादित करें`)
};

const pt_pt2_markers_edit_marker_label = /** @type {(inputs: Markers_Edit_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar marcador selecionado`)
};

/**
* | output |
* | --- |
* | "Edit selected marker" |
*
* @param {Markers_Edit_Marker_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_edit_marker_label = /** @type {((inputs?: Markers_Edit_Marker_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Edit_Marker_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_edit_marker_label(inputs)
	if (locale === "de") return de_markers_edit_marker_label(inputs)
	if (locale === "it") return it_markers_edit_marker_label(inputs)
	if (locale === "ru") return ru_markers_edit_marker_label(inputs)
	if (locale === "es") return es_markers_edit_marker_label(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_edit_marker_label(inputs)
	if (locale === "ja") return ja_markers_edit_marker_label(inputs)
	if (locale === "hi") return hi_markers_edit_marker_label(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_edit_marker_label(inputs)
	return en_markers_edit_marker_label(inputs)
});